import type {
  WorkstationCreateApiData,
  WorkstationCreateApiResponses,
  WorkstationDeleteApiData,
  WorkstationDeleteApiResponses,
  WorkstationGetApiData,
  WorkstationGetApiResponses,
  WorkstationListApiData,
  WorkstationListApiResponses,
  WorkstationPatchApiData,
  WorkstationPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getStationUrls = {
  getPaginatedStations: dataEndpoint<WorkstationListApiData, WorkstationListApiResponses>({
    getUrl: (queryParams) => apiUrl('workstations/', queryParams)
  }),
  getStation: dataEndpoint<WorkstationGetApiData, WorkstationGetApiResponses>({
    getUrl: ({ workstationId }) => apiUrl(`workstations/${workstationId}/`)
  }),
  postStation: responseEndpoint<WorkstationCreateApiData, WorkstationCreateApiResponses>({
    getUrl: () => apiUrl('workstations/'),
    getBody: (data) => data
  }),
  patchStation: responseEndpoint<WorkstationPatchApiData, WorkstationPatchApiResponses>({
    getUrl: ({ workstationId }) => apiUrl(`workstations/${workstationId}/`),
    getBody: ({ workstationId: _, ...body }) => body
  }),
  deleteStation: dataEndpoint<WorkstationDeleteApiData, WorkstationDeleteApiResponses>({
    getUrl: ({ workstationId }) => apiUrl(`workstations/${workstationId}/`)
  })
};
